import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function CommunitySchoolPage() {
  return (
    <div className="main-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <EditableText id="community-school.title" defaultContent="社区事工/中文学校" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>社区事工/中文学校</h1>
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="community-school.body"
          defaultContent={"中文学校（Chinese School）：通过对社区儿童学业的帮助，引导他们认识上帝。\n中文学校的具体做法：\n1. 针对小学和初中的学生。\n2. 计划设立不同科目对学生的学业进行帮助。例如：中文班、英文班、数学班、家庭作业辅导班等等。目前，只有中文班。\n在开班学习之前，有儿童赞美诗歌的教唱和《圣经》故事分享。\n面前中文学校需要有意教导中文的老师和志愿者。如果您计划参与中文学校，请和我们联系：[RiverofLifeCCU@Gmail.com](mailto:RiverofLifeCCU@Gmail.com) 或者点击下面的菜单。\n如果您愿意参与中文的教导，或您希望您的孩子参加中文的学习，请点击下面的菜单联系我们！"}
          defaultStyle={BODY_STYLE}
        />
      </section>
      <section style={{ margin: "32px 0", textAlign: "center" }}>
        <a
          href="mailto:RiverofLifeCCU@gmail.com"
          style={{ display: "inline-block", background: "#0693e3", color: "#fff", padding: "12px 32px", borderRadius: 6, textDecoration: "none", fontWeight: 600 }}
        >
          <EditableText
            id="community-school.contact-btn"
            as="span"
            defaultContent="联系我们"
            defaultStyle={{ color: "#fff", fontWeight: 600 }}
          />
        </a>
      </section>
      <PageCopyright pageId="community-school" />
    </div>
  );
}

export default CommunitySchoolPage;
